import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Copyright = styled.div`
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
`;

export const CopyrighLeft = styled.div`
    display: block;
`;

export const CopyrightCompany = styled.p`
    color: ${COLORS.GRAY_DARK};
    ${FONTS.XS};
    text-align: end;
`;

export const CopyrightText = styled.p`
    max-width: 600px;
    ${FONTS.XS};
    color: ${COLORS.GRAY_DARK};
  
    &:not(:first-child) {
        margin-top: 16px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        &:last-child {
            margin-bottom: 16px;
        }
    }
`;

export const CopyrightLink = styled.a`
    border-bottom: 1px solid currentColor;
    color: currentColor;
    transition: 0.25s;

    &:hover {
        color: ${COLORS.Control};
    }
`;
